// extracted by mini-css-extract-plugin
export var orderSummary = "_qf-0";
export var showMoreLessButton = "_qf-1";